import React from 'react';
import { useAuth } from '../contexts/AuthContext';

function PendingApproval() {
    const { user, logout } = useAuth();

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-logo">
                    <span className="login-logo-icon">&#9200;</span>
                    <h1>Aguardando Aprovacao</h1>
                    <p>Sua conta esta pendente de aprovacao pelo administrador</p>
                </div>

                <div className="pending-info">
                    <div className="pending-user-info">
                        {user?.picture && (
                            <img
                                src={user.picture}
                                alt={user.name}
                                className="pending-user-avatar"
                                referrerPolicy="no-referrer"
                            />
                        )}
                        <div>
                            <strong>{user?.name}</strong>
                            <p>{user?.email}</p>
                        </div>
                    </div>
                    <p className="pending-message">
                        O administrador sera notificado do seu pedido de acesso.
                        Tente novamente mais tarde.
                    </p>
                </div>

                <button className="btn btn-secondary" onClick={logout} style={{ width: '100%' }}>
                    Sair
                </button>
            </div>
        </div>
    );
}

export default PendingApproval;
